{
  "table": {
    "ranAt": "Ran At",
    "type": "Type",
    "numPortfolios": "# of Portfolios",
    "organization": "Organization",
    "state": "State",
    "actions": "Actions",
    "run": "Run",
    "bulkV2Unavailable": "Bulk optimization isn't available for Optimizer V2 yet."
  },
  "filters": {
    "selectOrganization": "Select Organization"
  },
  "portfolioOptimizerType": {
    "DRIFT": "Drift",
    "TRANSFER": "Transfer"
  },
  "portfolioOptimizerState": {
    "CANCELED": "Canceled",
    "COMPLETED": "Completed",
    "FAILED": "Failed",
    "INITIATED": "Initiated",
    "SOLVING_FOR_PURCHASES": "Solving for purchases",
    "PURCHASES_SOLVED": "Purchases solved",
    "OPTIMAL_PORTFOLIOS_GENERATED": "Optimal portfolios generated",
    "OPTIMAL_PORTFOLIOS_GENERATING": "Optimal portfolios generating",
    "SOLVING_FOR_REDEMPTIONS": "Solving for redemptions",
    "REDEMPTIONS_SOLVED": "Redemptions solved",
    "REBALANCING": "Rebalancing",
    "REBALANCED": "Rebalanced",
    "TAX_OPTIMIZING": "Tax optimizing",
    "TAX_OPTIMIZED": "Tax optimized",
    "GENERATING_ALLOCATIONS": "Generating allocations"
  },
  "selectOptimizerModal": {
    "title": "Select Optimizer Type & Step",
    "subTitle": "Please select whether you would like to optimize portfolios based on drift or cash",
    "setType": "Select optimizer type",
    "setStep": "Select step to pause at",
    "TRANSFER": "Cash Optimizer",
    "DRIFT": "Drift Optimizer",
    "COMPLETE_ALL_STEPS": "Complete all steps",
    "OPTIMAL_PORTFOLIOS_GENERATED": "Step 1 - Optimal portfolios generated",
    "REDEMPTIONS_SOLVED": "Step 2 - Redemptions solved",
    "PURCHASES_SOLVED": "Step 3 - Purchases solved",
    "REBALANCED": "Step 4 - Rebalanced",
    "TAX_OPTIMIZED": "Step 5 - Tax optimized"
  },
  "detail": {
    "summaryResults": "Summary Results",
    "proceedToBulkTrader": "Proceed to Bulk Trader",
    "portfolioOptimizerState": "Portfolio Optimizer is in {{state}} state",
    "portfolioOptimizerNewState": "Portfolio Optimizer is now in {{state}} state",
    "cancel": "Cancel"
  },
  "stats": {
    "buys": "Buys",
    "sells": "Sells",
    "portfoliosAdjusted": "Portfolios Adjusted",
    "shares": "Shares",
    "amount": "Amount"
  },
  "transitions": {
    "cancel": "Cancel"
  },
  "run": "Run"
}
